export default "__VITE_ASSET__Bptyzqdu__"